import { useParams } from 'react-router-dom-v5-compat';
import { useSelector } from 'react-redux';
import { TEAM_TYPES } from 'common/constants/constants';
import { teamsWithExtraSyncedDataSelector } from 'state/selectors/teams';
import AddTeam from '../AddTeam/AddTeam';
import { isGroup } from 'common/utils/utils';

function EditTeam() {
  const { id = '' } = useParams();
  const teamId = parseInt(id) || 0;
  const teams = useSelector(teamsWithExtraSyncedDataSelector);
  const team = teams.find(({ id }) => id === teamId) || {};

  return (
    <AddTeam
      type={isGroup(team) ? TEAM_TYPES.GROUP : TEAM_TYPES.TEAM}
      team={team}
    />
  );
}

export default EditTeam;
